"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { fetchOnboardingState, updateOnboardingState } from "@/lib/api-client";
import { queryKeys } from "@/lib/query/keys";
import type { OnboardingState, OnboardingUpdatePayload } from "@/types/onboarding";

export function useOnboardingStateQuery(options?: { enabled?: boolean }) {
  return useQuery<OnboardingState>({
    queryKey: queryKeys.onboardingState(),
    queryFn: () => fetchOnboardingState(),
    enabled: options?.enabled ?? true,
  });
}

export function useUpdateOnboardingStateMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: OnboardingUpdatePayload) => updateOnboardingState(payload),
    onSuccess: (next) => {
      queryClient.setQueryData(queryKeys.onboardingState(), next);
    },
  });
}
